import React from 'react'
import Head from '../components/Head'
import Header from '../components/Header'
import Intro from '../components/IntroSecondary'
import Esports from '../components/esports'
import TriColumn from '../components/triColumn'
import BiColumn from '../components/biColumn'
import BiColumn__map from '../components/biColumn__map'
import BiColumn__leagues from '../components/biColumn__leagues'
import Footer from '../components/footer'
import Button from '../components/Button'

export default class extends React.Component {
  joinAsPlayer = () => {
    const url = `https://app.playvs.com/sign-up/player`
    window.open(url, '_blank')
  }

  joinAsCoach = () => {
    const url = `https://app.playvs.com/sign-up/coach`
    window.open(url, '_blank')
  }
  render() {
    return (
      <React.Fragment>
        <Head
          title="The Official High School Esports League | PlayVS"
          description="PlayVS is the official high school esports league, sanctioned by the NFHS. Play with your friends, compete for your school, and win the state championship."
          keywords="high school esports"
        />

        <Header />

        <Intro />

        <Esports />

        <TriColumn />

        <BiColumn />

        <BiColumn__map />

        <BiColumn__leagues />

        <section className="section section--blueGradient">
          <div className="container">
            <div className="section__head">
              <h2>Get Started</h2>
              <p>
                Administrators and players can create accounts and start the school approval process. Once
                your school is verified, get ready to lead your team to victory!{' '}
              </p>
            </div>
            <div className="section__CTA">
              <Button
                type="button"
                className="btn btn__reverse"
                text="Request to coach"
                onClick={this.joinAsCoach}
              />
              <Button
                type="button"
                className="btn btn__primary"
                text="Sign up to play"
                onClick={this.joinAsPlayer}
              />
            </div>
          </div>
        </section>

        <Footer />
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/pages/index.js